Vue.component('address-lookup', {
    props: ['quote_id', 'address'],

    data () {
        return {
            loading: false,

            addresses: [],
            availableAddresses: [],

            selected: '',

            line_1: '',
            line_2: '',
            city: '',
            country: '',
            region: '',
            post_code: '',

            coords: null
        };
    },

    mounted () {
        this.line_1 = this.address.address_1;
        this.line_2 = this.address.address_2;
        this.city = this.address.city;
        this.country = this.address.contact_country;
        this.region = this.address.contact_region;
        this.post_code = this.address.post_code;
    },

    methods: {
        selectAddress () {
            let address = this.availableAddresses[this.selected].formatted_address;

            this.line_1 = address[0] + (address[1].length > 0 ? ', ' + address[1] : '');
            this.line_2 = address[2];
            this.city = address[3];
            this.country = 'United Kingdom';
            this.region = address[4];

            $('#address-selector').modal('hide');
        },

        addressLookup () {
            if (this.post_code.length > 0) {
                $('#address-selector').modal('show');
                this.loading = true;
                this.addresses = [];

                axios.get('/api/address/lookup', {
                    params: {
                        post_code: this.post_code
                    }
                }).then((response) => {
                    this.loading = false;

                    if (response.data.length > 0) {
                        this.availableAddresses = response.data;

                        for (let address of response.data) {
                            let toAdd = '';

                            for (var x = 0; x < 4; x++) {
                                if (address.formatted_address[x].length > 0) {
                                    if (toAdd.length === 0) {
                                        toAdd += address.formatted_address[x];
                                    } else {
                                        toAdd += ', ' + address.formatted_address[x];
                                    }
                                }
                            }

                            this.addresses.push(toAdd);
                        }
                    }
                });
            }
        }
    }
});